const fields = {
  id: { isForDispo: true, isForZueri9: true },
  createdAt: { isForDispo: true, isForZueri9: true },
  lastModifiedAt: { isForDispo: true, isForZueri9: true },
  reason: { isForDispo: true, isForZueri9: false },
  crewReport: { isForDispo: true, isForZueri9: false },
  supervisorReport: { isForDispo: true, isForZueri9: false },
  department: { isForDispo: true, isForZueri9: false },
  anonymousIllnessReason: { isForDispo: true, isForZueri9: false },
  illnessReason: { isForDispo: true, isForZueri9: false },
  vbzNr: { isForDispo: true, isForZueri9: false },
  zueri9VbzNr: { isForDispo: false, isForZueri9: true },
  duty: { isForDispo: true, isForZueri9: true },

  dutyFrom: { isForDispo: true, isForZueri9: true },
  dutyFromLoc: { isForDispo: true, isForZueri9: true },
  dutyUntil: { isForDispo: true, isForZueri9: true },
  dutyUntilLoc: { isForDispo: true, isForZueri9: true },
  line: { isForDispo: true, isForZueri9: true },

  dutyFromP2: { isForDispo: true, isForZueri9: true }, // P2= part 2
  dutyFromLocP2: { isForDispo: true, isForZueri9: true },
  dutyUntilP2: { isForDispo: true, isForZueri9: true },
  dutyUntilLocP2: { isForDispo: true, isForZueri9: true },
  lineP2: { isForDispo: true, isForZueri9: true },

  duty2: { isForDispo: true, isForZueri9: false },
  dutyFrom2: { isForDispo: true, isForZueri9: false },
  dutyFromLoc2: { isForDispo: true, isForZueri9: false },
  dutyUntil2: { isForDispo: true, isForZueri9: false },
  dutyUntilLoc2: { isForDispo: true, isForZueri9: false },
  line2: { isForDispo: true, isForZueri9: false },

  duty2P2: { isForDispo: true, isForZueri9: false },
  dutyFrom2P2: { isForDispo: true, isForZueri9: false },
  dutyFromLoc2P2: { isForDispo: true, isForZueri9: false },
  dutyUntil2P2: { isForDispo: true, isForZueri9: false },
  dutyUntilLoc2P2: { isForDispo: true, isForZueri9: false },
  line2P2: { isForDispo: true, isForZueri9: false },

  zueri9Remarks: { isForDispo: true, isForZueri9: true },
  zueri9Client: { isForDispo: false, isForZueri9: true },
  zueri9Reason: { isForDispo: false, isForZueri9: true },

  backup1: { isForDispo: true, isForZueri9: false },
  backup1_reported: { isForDispo: true, isForZueri9: false },
  backup1_until: { isForDispo: true, isForZueri9: false },
  backup2: { isForDispo: true, isForZueri9: false },
  backup2_reported: { isForDispo: true, isForZueri9: false },
  absenceDuration: { isForDispo: true, isForZueri9: false },
  remark: { isForDispo: true, isForZueri9: false },
  reportingDate: { isForDispo: true, isForZueri9: false },
  reportedAtTime: { isForDispo: true, isForZueri9: false },
  dispoState: { isForDispo: true, isForZueri9: false },
  zueri9State:{ isForDispo: false, isForZueri9: true },
  setAsCompleted:{ isForDispo: true, isForZueri9: false },
};
export default fields;
